import { Control, UseFormGetValues, UseFormSetValue } from 'react-hook-form';

/**
 * This repo's `useHookForm.register(name)` returns `{ control, name, disabled }`
 * (common/src/hooks/useHookForm.ts:86) — NOT native RHF register. So the field is
 * driven by a Controller, exactly as common's FormField/TextFieldVariant does.
 */
export interface ICompanyAutocompleteExtraProps {
  control: Control<any>;
  name: string;
  disabled?: boolean;
}

export interface ICompanyOption {
  text: string;
  value: string | number;
  selected?: boolean;
  logo?: string | null;
  category?: string | null;
  location?: string | null;
  /** Synthetic trailing "keep what I typed" option (no directory link). */
  keep?: boolean;
}

export interface IDefaultSupplier {
  id?: number | null;
  title?: string | null;
}

export interface ICompanyAutocompleteProps {
  /** register('companyName') → { control, name, disabled } — drives the visible text field. */
  extraProps: ICompanyAutocompleteExtraProps;
  /** Registered form field for the hidden Nombase supplier id (number | null). */
  supplierIdName: string;
  /** Registered form field for the hidden Nombase supplier title (string | null). */
  supplierTitleName: string;
  setValue: UseFormSetValue<any>;
  getValues: UseFormGetValues<any>;
  errors?: any;
  /** Seeds the LINKED state on mount / step re-entry (server prefill on EditJob). */
  defaultSupplier?: IDefaultSupplier;
  label?: string;
  isRequired?: boolean;
  maxLength?: number;
  fieldComment?: string;
  /** When true, editing the text after a pick keeps the link (unused product flip). */
  keepLinkOnEdit?: boolean;
}

/** Trimmed length gate for the supplier search — mirrors the backend `SearchSupplier`. */
export const MIN_SEARCH_LEN = 3;

export const SEARCH_DEBOUNCE_MS = 800;

export const DEFAULT_COMPANY_HELPER = 'Match your company in the Nombase directory as you type. Linking powers a dedicated company page and shows your logo on the listing. For a confidential listing, keep the name as written and describe your company in general terms.';

/** Shown under the chip once a directory company is linked. */
export const LINKED_COMPANY_HELPER = 'This listing links to your Nombase company page and shows your logo.';
